/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';

/**
 * The bubble that `ptl-tooltip` and `[ptlTooltip]` show: one look for both. Internal to the tooltip folder; it is
 * placed by `positionTooltip`, which also adds the `wrapped` and `out-of-view` classes to it.
 */
@Component({
  selector: 'ptl-tooltip-bubble',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tooltip-bubble',
    role: 'tooltip',
    popover: 'manual',
    '[class.multiline]': 'multiline()',
  },
  template: `
    @for (part of parts(); track $index) {
      @if (!$first) {
        <span class="tooltip-separator">{{ separator() }}</span>
      }
      <span class="tooltip-part">{{ part }}</span>
    }
  `,
  styleUrls: ['./ptl-tooltip-bubble.component.scss'],
})
export class PtlTooltipBubbleComponent {
  /** Non-empty pieces of text: one line joined by `separator` while that fits, else a line each. */
  parts = input<readonly string[]>([]);
  separator = input(' · ');
  /** Wraps at a readable width instead of the window's. */
  multiline = input(false, { transform: booleanAttribute });
}
